import { en } from './en';

export const zh = {
    COMMON: {
        ...en.COMMON,
        HHCCN: {
            LANGUAGE: {
                SECTION_TITLE: '語言',
            },
            CHANGES: {
                SECTION_TITLE: '居家健康照護變更通知 (HHCCN)',
                FIELD1: '哪些項目/服務正在改變？',
                FIELD2: '變更原因',
                ADD_ITEM: '新增項目',
            },
            STARTING_DATE: {
                SECTION_TITLE: '開始日期',
                LABEL: '變更開始日期',
            },
            NOTICE_REASON: {
                SECTION_TITLE: '為什麼您會收到這個通知？',
                OPTION1: {
                    LABEL: '您的醫生/提供者更改（或未續簽）您的居家護理指示。',
                    DESCRIPTION:
                        '居家健康機構必須遵循醫生/提供者的指示為您提供護理。如果您不同意此更改，請與您的居家健康機構或為您安排居家護理的醫生/提供者討論。',
                },
                OPTION2: {
                    LABEL: '由於上述原因，您的居家健康機構決定停止向您提供物品/服務。',
                    DESCRIPTION:
                        '如果您認為您仍然需要居家護理，並且您有有效醫生指示，則可以向其他居家健康機構尋求護理。如需尋找其他居家健康機構的協助，請聯絡為您安排居家護理的醫生/提供者。如果您從其他居家健康機構獲得護理，您可以要求其向聯邦醫療保險開立帳單。',
                },
            },
            GET_HELP: {
                SECTION_TITLE: '獲取幫助或更多信息',
                CONTENT:
                    '如果您對這些變化有疑問，請聯絡您的居家健康機構和/或為您安排居家護理的醫生/提供者。除非您收到物品/服務並且提交了聯邦醫療保險索賠，否則您不能就上述物品/服務的付款問題向聯邦醫療保險提出申訴。',
            },
            OPTIONAL_DETAILS: {
                SECTION_TITLE: '額外細節',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: '簽名',
                HEADING: '在下面簽名以表明您理解本通知',
                AGREE: '病人或授權代表同意以電子簽名方式簽署本文件。',
                PATIENT_AGREE: '病人同意以電子簽名方式簽署本文件。',
                REPRESENTATIVE_AGREE: '授權代表同意以電子簽名方式簽署本文件。',
                AUTHORIZED_REP: '若您以授權代表的身份簽字，請勾選此處，並確保您的姓名清晰可辨，如果難以辨認，請用正楷書寫您的姓名。',
                AUTHORIZED_REP_NAME_LABEL: '授權代表姓名',
                AUTHORIZED_REP_NAME_PLACEHOLDER: '名字和姓氏',
                AUTHORIZED_REP_FALLBACK: '授權代表',
                REFUSED_TO_SIGN: '病人拒絕簽署',
            },
            ACCESSIBILITY: {
                CONTENT:
                    '您有權以可訪問的格式獲取您的訊息，例如大字體、點字或音訊。如果您認為自己受到歧視，您也有權利提出申訴。請訪問 Medicare.gov/about-us/accessibility-nondiscrimination-notice，或致電 1-800-MEDICARE (1-800-633-4227) 以了解更多資訊。TTY 用戶可以撥打 1-877-486-2048。',
            },
        },
    },
};
